import React from "react";
import { useTranslation } from "react-i18next";
import hardwareAnimation from "../../img/animations/animation-hardware.gif";
import OnboardingFrame from "./onboarding-frame";
import { OnboardingFrameProps } from "./onboarding-shared-data";
import * as styles from "./onboarding-step-hardware.module.scss";
import { hardwareSetupSupportURL } from "../../constants";

export default function OnboardingStepHardware(props: OnboardingFrameProps) {
	const { t } = useTranslation();
	return (
		<OnboardingFrame
			title={t("onboarding.hardware.title")}
			description={
				<>
					{t("onboarding.hardware.description_prefix")}
					<p>
						<a
							href={hardwareSetupSupportURL}
							target="_blank"
							rel="noreferrer"
						>
							{hardwareSetupSupportURL}
						</a>
					</p>
				</>
			}
			buttonSecondary={{
				label: t("onboarding.hardware.back"),
				onClick: props.navigateBackwards,
			}}
			buttonPrimary={{
				label: t("onboarding.hardware.next"),
				onClick: props.navigateForwards,
			}}
			centerContent
		>
			<img className={styles.image} src={hardwareAnimation} alt="" />
		</OnboardingFrame>
	);
}
